import { render, staticRenderFns } from "./PloomesIcon.vue?vue&type=template&id=ca51af4e&"
import script from "./PloomesIcon.vue?vue&type=script&lang=ts&"
export * from "./PloomesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports